import React, { FunctionComponent } from "react"

interface Speed1on1IconProps {}

const Speed1on1Icon: FunctionComponent<Speed1on1IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7778 4.22223L5 13.5556H12L11.2222 19.7778L19 10.4445H12L12.7778 4.22223Z"
        fill="#475766"
        stroke="#475766"
        stroke-width="1.55556"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="6" cy="7" r="4.5" fill="#05AAFF" stroke="#E6F7FF" />
      <circle cx="18" cy="17" r="4.5" fill="#05AAFF" stroke="#E6F7FF" />
    </svg>
  )
}

export default Speed1on1Icon
